/** Shared base segment for module configurator lifecycle event names. */
export const ModuleConfiguratorEventBaseName = 'ModuleConfigurator';
export default ModuleConfiguratorEventBaseName;
//# sourceMappingURL=module-configurator-event-base-name.js.map